import React from 'react'
import { Box } from '@mui/material'

// Shared pill-style segmented control for list-style pages (Favorites,
// Appointments, ...). tabs: [{ key, label }]. Kept as one implementation so
// the two pages' tab switchers can't visually drift apart again.
export default function SegmentedTabs({ tabs, value, onChange, sx }) {
  return (
    <Box sx={{
      display: 'flex',
      bgcolor: 'action.hover',
      borderRadius: 10,
      p: 0.5,
      gap: 0.5,
      flexShrink: 0,
      ...sx,
    }}>
      {tabs.map(({ key, label }) => (
        <Box
          key={key}
          onClick={() => onChange(key)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onChange(key) }}
          sx={{
            flex: 1,
            textAlign: 'center',
            py: 1,
            borderRadius: 10,
            cursor: 'pointer',
            fontWeight: 700,
            fontSize: '0.85rem',
            userSelect: 'none',
            bgcolor: value === key ? 'background.paper' : 'transparent',
            color: value === key ? 'primary.main' : 'text.secondary',
            boxShadow: value === key ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
            transition: 'all 0.2s',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          {label}
        </Box>
      ))}
    </Box>
  )
}
